import SubmissionModules from 'features/submissions/components/SubmissionModules/SubmissionModules';

export default SubmissionModules;
